let audioContext = null;

function getAudioContext() {
  if (typeof window === 'undefined') return null;
  const AudioCtx = window.AudioContext || window.webkitAudioContext;
  if (!AudioCtx) return null;
  if (!audioContext) audioContext = new AudioCtx();
  return audioContext;
}

export async function requestMessageNotificationPermission() {
  if (typeof window === 'undefined' || !('Notification' in window)) return Notification?.permission;
  if (Notification.permission !== 'default') return Notification.permission;
  try {
    return await Notification.requestPermission();
  } catch (_) {
    return Notification.permission;
  }
}

export function unlockMessageNotificationSound() {
  const ctx = getAudioContext();
  if (!ctx) return;

  try {
    const buffer = ctx.createBuffer(1, 1, 22050);
    const source = ctx.createBufferSource();
    source.buffer = buffer;
    source.connect(ctx.destination);
    source.start(0);
  } catch (_) { /* ignore */ }

  if (ctx.state === 'suspended') {
    ctx.resume().catch(() => {});
  }
}

export function playMessageNotificationSound() {
  try {
    const ctx = getAudioContext();
    if (!ctx) return;

    const startPlayback = () => {
      const now = ctx.currentTime;
      const playTone = (frequency, start, duration, volume = 0.14) => {
        const oscillator = ctx.createOscillator();
        const gain = ctx.createGain();
        oscillator.type = 'sine';
        oscillator.frequency.value = frequency;
        gain.gain.setValueAtTime(0.0001, start);
        gain.gain.exponentialRampToValueAtTime(volume, start + 0.015);
        gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);
        oscillator.connect(gain);
        gain.connect(ctx.destination);
        oscillator.start(start);
        oscillator.stop(start + duration + 0.02);
      };

      playTone(880, now, 0.11);
      playTone(1174.66, now + 0.09, 0.14);
    };

    if (ctx.state === 'suspended') {
      ctx.resume().then(startPlayback).catch(() => {});
      return;
    }

    startPlayback();
  } catch (_) { /* ignore */ }
}
